import React from 'react';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { styled } from '@mui/material/styles';

const BodyContainer = styled('div')(({ theme }) => ({
  height: '40vh',
  marginTop: '80px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '40px',
}));

const StyledErrorIcon = styled(ErrorOutlineIcon)(({ theme }) => ({
  fontSize: '60px',
}));

function NotFound(props) {
  return (
    <React.Fragment>
      {props?.match?.params?.id ? (
        <BodyContainer>
          <StyledErrorIcon />
          404: Page not found
        </BodyContainer>
      ) : (
        <div>
          <BodyContainer>
            <StyledErrorIcon />
            404: Page not found
          </BodyContainer>
        </div>
      )}
    </React.Fragment>
  );
}

export default NotFound;
